<template>
  <div>
    <delete-modal
      :yesFunc="deleteItem"
      ref="deleteModalRef"
      :description="$t('description.deleteContent')"
      :title="$t('title.deleteContentTitle')"
    />

    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
       <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <div class="text-h6">
              {{ moduleDetail.Name }}
            </div>
          </v-col>

          <v-col cols="auto">
            <v-btn
              @click="$router.push({ name: 'addContentAdd' })"
              small
              elevation="0"
              outlined
              color="var(--primary-color)"
            >
              <v-icon left small>mdi-plus</v-icon>
              {{ $t("buttons.addNew") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />
      <v-layout v-if="pageRules.isCategoryView">
        <v-flex md8 class="pr-10">
          <v-card-text class="pt-4">
            <v-row align="center" justify="space-between">
              <v-col cols="3" class="mb-3">
                <v-text-field
                  v-model="filters.Search"
                  append-icon="mdi-magnify"
                  @click:append="getTableList"
                  :label="$t('labels.search')"
                  v-on:keyup.enter="getTableList"
                  @click:clear="filters.Search = ''; getTableList()"
                  clear-icon="mdi-close-circle"
                  clearable
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="tableData"
              :loading="loadings.table"
              :options.sync="pagination"
              :hide-default-footer="true"
              :footer-props="{
                disablePagination: true,
                disableItemsPerPage: true,
              }"
              :no-data-text="$t('description.noList')"
            >
              <!-- eslint-disable -->
              <template v-slot:item.Title="{ item }">
                <div style="font-weight: bold !important">
                  {{ item.Title.length > 50 ? item.Title.substring(0, 50) + '...' : item.Title }}
                </div>
              </template>
              <template v-slot:item.Content="{ item }">
                <div
                  style="
                    max-height: 40px;
                    max-width: 300px;
                    overflow-y: scroll;
                    overflow-y: hidden;
                  "
                  v-html="
                    item.Content.length > 0 ? item.Content : 'İçeriksiz Gönderi'
                  "
                ></div>
              </template>
              <template v-slot:item.Status="{ item }">
                <div style="font-weight: bold !important">
                  {{ item.Status }}
                </div>
              </template>
              <template v-slot:item.Groups="{ item }">
                <v-tooltip top v-if="item.Groups.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip color="transparent" label v-bind="attrs" v-on="on">
                      <div
                        class="text-truncate text-center"
                        style="width: 150px"
                      >
                        {{ item.Categories.length }} Adet Şirket
                      </div>
                    </v-chip>
                  </template>
                  <span v-html="getCompanyNames(item)"></span>
                </v-tooltip>
                <v-tooltip top v-if="item.Categories.length == 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip color="transparent" label v-bind="attrs" v-on="on">
                      <div
                        class="text-truncate text-center"
                        style="width: 150px"
                      >
                        {{ $t("labels.noCategory") }}
                      </div>
                    </v-chip>
                  </template>
                  {{ $t("labels.noCategorySelected") }}
                </v-tooltip>
              </template>
              <template v-slot:item.CreatedAt="{ item }">
                {{ convertToLocal(item.CreatedAt) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      @click="getDetails(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>{{ $t("labels.tooltipEdit") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-if="item.Status == 20"
                      @click="publishOperation(item, 20)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-publish-off
                    </v-icon>
                  </template>
                  <span>{{ $t("labels.unPublish") }}</span>
                </v-tooltip>
         
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-if="item.Status == 20 || item.Status == 0"
                      @click="publishOperation(item, 10)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-publish
                    </v-icon>
                  </template>
                  <span>{{ $t("labels.publishItem") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="item.Status !== 30"
                      small
                      @click="openDeleteModal(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>{{ $t("labels.tooltipDelete") }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="text-xs-center pt-2 md4 lg4">
              <v-pagination
                @input="paginationChangeHandler"
                :value="pagination.page"
                :length="pages"
                :total-visible="10"
                circle
              ></v-pagination>
            </div>
          </v-card-text>
        </v-flex>

        <v-divider vertical></v-divider>

        <v-flex md4 class="pl-10">
          <v-card-text class="pt-4 mb-3">
            <v-text-field
              v-model="searchCategory"
              :label="$t('labels.searchCategory')"
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
            <v-treeview
              class="pt-10"
              return-object
              v-model="selectedCategoriesModal"
              :items="categoryData"
              selection-type="leaf"
              item-children="Children"
              item-value="Id"
              item-text="CategoryNameTR"
              item-key="Id"
              :search="searchCategory"
              :filter="filter"
              color="#7443a0"
              open-all
              activatable
              open-on-click
              @update:active="selectOneCategory"
              style="overflow: auto; height: 1000px"
            ></v-treeview>
            <template slot-scope="{ item }">
              <a @click="selectOneCategory(item)">{{ item.CategoryNameTR }}</a>
            </template>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-card-text v-if="!pageRules.isCategoryView">
        <v-row class="mb-4" align="center">
          <v-col cols="2">
            <StatusSelect 
              :label="$t('labels.status')"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
              prepend-icon="mdi-filter-cog"
              v-model="filters.Status"
              @change="pagination.page = 1; getTableList()"
            />
          </v-col>
          <v-col cols="2">
            <v-menu v-model="datePickerVisible" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('labels.startDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  style="fontSize: 11px;"
                />
              </template>
              <v-date-picker v-model="minimumDate" locale="tr-TR">
                <v-spacer />
                <v-btn text color="primary" @click="clearDateFilter">
                  {{ $t(`buttons.${minimumDate?.length > 0 ? 'clear' : 'cancel'}`) }}
                </v-btn>
                <v-btn text color="primary" @click="applyDateFilter">
                  {{ $t("buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="auto" class="ml-auto">
            <v-text-field
              v-model="filters.Search"
              append-icon="mdi-magnify"
              @click:append="getTableList"
              :label="$t('labels.search')"
              v-on:keyup.enter="getTableList"
              @click:clear="filters.Search = ''; getTableList()"
              clear-icon="mdi-close-circle"
              clearable
              single-line
              hide-details
              style="min-width: 250px"
            />
          </v-col>
        </v-row>

        <v-row class="mb-4" v-if="selectedPostsCount > 0">
          <v-col cols="12">
            <v-divider  class="mb-4" />
            {{ selectedPostsCount }} adet gönderi seçildi.
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="quickUpdateStatus"
              :items="[
                { label: 'Sil', value: 'delete' },
                { label: 'Düzenle', value: 'update' }
              ]"
              :label="$t('labels.action')"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <!-- UPDATE seçilince ikinci select -->
          <v-col cols="3" v-if="quickUpdateStatus === 'update'">
            <StatusSelect
              v-model="updateStatusValue"
              :items="statusItems"
              label="Durum"
              clearable
              hide-details
              :inactiveValues="[null, 30]"
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <v-col cols="3" v-if="canApplyBulkUpdate">
            <v-btn
              small
              class="ma-4 mr-8"
              elevation="0"
              outlined
              color="info"
              @click="bulkUpdate()"
            >
              {{ $t('buttons.apply') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          show-select
          v-model="selectedItems"
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="pagination"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          item-key="Id"
          :no-data-text="$t('description.noList')"
          @click:row="getDetails"
          :item-class="() => 'clickable-row'"
        >
          <!-- eslint-disable -->
          <template v-slot:item.Title="{ item }">
              <v-tooltip top v-if="item.Groups.length > 0">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="font-weight: bold !important">
                    {{ item.Title.length > 35 ? item.Title.substring(0, 35) + '...' : item.Title }}
                  </span>
                  </template>
                  <span v-html="getCompanyNames({ Groups: [{ Name: item.Title }] })"></span>
              </v-tooltip>
          </template>
          <template v-slot:item.Content="{ item }">
            <div
              style="
                max-height: 40px;
                max-width: 300px;
                overflow-y: scroll;
                overflow-y: hidden;
              "
              v-html="
                item.Content.length > 0 ? item.Content : 'İçeriksiz Gönderi'
              "
            ></div>
          </template>
          <template v-slot:item.Creator="{ item }">
            {{ item?.User 
                ? `${item.User.Name} ${item.User.Surname}` 
                : 'Atanmamış' }}
          </template>
          <template v-slot:item.Status="{ item }">
            <v-chip v-if="isScheduled(item.SendedAt) && item.Status === 10" :color="statusMap['Scheduled'].color">
              <span :style="{ color: statusMap['Scheduled'].textColor }">
                <v-icon class="mr-1" dark>
                  mdi-clock
                </v-icon> {{ statusMap['Scheduled'].text }}
              </span>
            </v-chip>
            <div v-else style="font-weight: bold !important;">
              <v-chip :color="statusMap[item.Status].color">
                <span :style="{ color: statusMap[item.Status].textColor }">
                  {{ statusMap[item.Status].text }}
                </span>
              </v-chip>
            </div>
          </template>
          <template v-slot:item.Categories="{ item }">
            <v-tooltip top v-if="item.Groups.length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="transparent" label v-bind="attrs" v-on="on">
                  <div class="text-truncate text-center" style="width: 150px">
                    {{ item.Groups.length }} Adet Şirket
                  </div>
                </v-chip>
              </template>
              <span v-html="getCompanyNames(item)"></span>
            </v-tooltip>
            <v-tooltip top v-if="item.Groups.length == 0">
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="transparent" label v-bind="attrs" v-on="on">
                  <div class="text-truncate text-center" style="width: 150px">
                    {{ $t("labels.noCategory") }}
                  </div>
                </v-chip>
              </template>
              {{ $t("labels.noCategorySelected") }}
            </v-tooltip>
          </template>
          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click.stop="getDetails(item)"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  class="mr-2"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status === 10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  small
                  @click.stop="publishOperation(item, 20)"
                  v-bind="attrs"
                  v-on="on"
                  style="color: gray !important;"
                >
                  mdi-publish-off
                </v-icon>
              </template>
              <span>{{ $t("labels.unPublish") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status === 10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  small
                  @click.stop="copy(item?.Id)"
                  v-bind="attrs"
                  v-on="on"
                  style="color: #006A99 !important;"
                >
                  mdi-content-duplicate
                </v-icon>
              </template>
              <span>{{ $t("buttons.copy") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status !== 10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  small
                  @click.stop="publishOperation(item, 10)"
                  v-bind="attrs"
                  v-on="on"
                  color="sucess"
                >
                  mdi-publish
                </v-icon>
              </template>
              <span>{{ $t("labels.publishItem") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status !== 30">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  small
                  @click.stop="openDeleteModal(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-row class="my-2">
          <v-spacer />

          <v-col cols="3">
            <v-select
              v-model="pagination.itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="getTableList"
            />
          </v-col>
        </v-row>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ContentService from "../services/ContentService";
import ModuleService from "../services/ModuleService";
import PostService from "../services/PostService";
import CategoryService from "../services/CategoryService";
import DeleteModal from "../components/General/DeleteModal";
import StatusSelect from "../components/StatusSelect.vue";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat)
dayjs.extend(utc);

export default {
  data: () => ({
    quickUpdateStatus: null,
    updateStatusValue: null,
    selectedItems: [],
    statusMap: {
      0: { text: "Taslak", color: "#f5f5f5", textColor: "#666" },
      10: { text: "Yayında", color: "green", textColor: "white" },
      20: { text: "Pasif", color: "#bdbdbd", textColor: "#444" },
      30: { text: "Silindi", color: "#FF7066", textColor: "white" },
      Scheduled: { text: "Zamanlandı", color: "#03aecc", textColor: "white" }
    },
    //List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    key: "",
    //Table contents
    headers: [],

    //Page loaders
    loadings: {
      table: false,
      send: false,
    },

    //Page detail
    moduleDetail: {},

    //delete model item
    deleteItemModel: {},

    search: "",
    //Pagination models
    pagination: {
      itemsPerPage: 15,
      page: 1,
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
    pageHeader: "",
    pageId: -1,
    moduleDescription: "",
    //Page restrictions
    pageRules: null,
    selectedCategoriesModal: [],
    categoryData: [],
    searchCategory: "",

    filters: {
      Status: null,
      Search: ""
    },

    minimumDate: "",
    datePickerVisible: false,
  }),
  watch: {},
  beforeMount() {
    this.pageRules = getPageRulesById(this.$route.params.id);
    this.moduleDetail = {
      Name: this.pageRules.adi,
      Key: this.pageRules.key
    }
  },
  mounted() {
    this.setup();
    this.getModuleDetail();
  },
  components: {
    StatusSelect,
    DeleteModal,
  },
  computed: {
    canApplyBulkUpdate(){
      let canApply = false;

      if(this.quickUpdateStatus === "delete") canApply = true;
      else if(this.quickUpdateStatus === "update" && this.updateStatusValue !== undefined && this.updateStatusValue !== null) canApply = true;
      
      return canApply;
    },
    selectedPostsCount(){
      return this.selectedItems.length || 0;
    },
    dateRangeText() {
      return this.minimumDate ? dayjs(this.minimumDate).format('DD.MM.YYYY') : ""
    },
        
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.itemsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.itemsPerPage
      );
    },

    filter() {
      return this.true
        ? (item, searchCategory, textKey) =>
            item[textKey].indexOf(searchCategory) > -1
        : undefined;
    },
  },
  methods: {
    isScheduled(date) {
      const scheduledDate = dayjs.utc(date, 'D.MM.YYYY HH:mm:ss')
      return scheduledDate.isAfter(dayjs())
    },

    bulkUpdate(){
      let status = null;

      if(this.quickUpdateStatus === "delete"){
        status = 30;
      }
      else if(this.quickUpdateStatus === "update"){
        status = this.updateStatusValue;
      }

      if(status === null || status === undefined) return;

      const items = this.selectedItems.flatMap(item => item.Id);

      if(Array.isArray(items) && items.length > 0){
        this.$store.state.loadingStatus = true;
        PostService.bulkUpdate(items, status)
        .then(() => {
          window.showSuccess("Verileriniz başarılı bir şekilde güncellendi.")
          this.getTableList()
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
      }
      
    },
    copy(postId){
      this.$store.state.loadingStatus = true;
      PostService.copyPost(Number(postId))
      .then(response => {
        const data = response?.data;
        if(data?.Id){
          this.$router.push({
            path: `/home/updateContent/${data.Id}`,
            query: {
              pageName: this.pageHeader || "",
              moduleDescription: data.Description || "",
              pageId: data.Key || -1,
            },
          });
        }
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },

    clearDateFilter() {
      this.minimumDate = null;
      this.datePickerVisible = false;
      this.getTableList();
    },
    applyDateFilter() {
      this.datePickerVisible = false;
      this.getTableList()
    },
    
    tableTitle(item) {
      return item.Content <= 0 ? "İçeriksiz Gönderi" : item.Content;
    },

    async setup() {
      this.headers = [
        { text: "Başlık", value: "Title", sortable: false },
        // { text: "İçerik", value: "Content", sortable: false },
        { text: "Ekleyen", value: "Creator", sortable: false },
        {
          text: "Tanımlı Şirketler",
          value: "Categories",
          sortable: false,
          align: "center",
        },
        { text: "Oluşturulma Tarihi", value: "CreatedAt", sortable: false },
        { text: "Durumu", value: "Status", sortable: false },
        { text: "İşlem", value: "actions", sortable: false },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
      await this.getCategories();
    },
    async getCategories() {
      return new Promise(async (resolve, reject) => {
        try {
          if (this.pageRules.categoryIds.length > 0) {
            await Promise.all(
              this.pageRules.categoryIds.map(async (element, index) => {
                await CategoryService.getCategoriesInTreeView(element.id)
                  .then((res) => {
                    this.categoryData = this.categoryData.concat(res.data);
                  })
                  .catch((err) => {
                    window.handleServiceError(res, err);
                  })
                  .then(() => {});
              })
            );
          }
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
    //Loads page detail
    getModuleDetail() {
      // FIXME: Böyle bir yer yok.
      this.getTableList();
      return;
      ModuleService.getModuleDetails(this.$route.params.id)
        .then((res) => {
          this.moduleDetail = res.data;
          console.log("MODULE DETAIL > ", this.moduleDetail);
          this.pageId = this.moduleDetail.Id;
          this.moduleDescription = res.data.LongDescription;
          this.key = res.data.Key;

          this.getTableList();
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {});
    },

    //Loads page list
    getTableList(categoryId = "", flag = false) {
      if (flag) 
        this.loadings.table = true;
      else 
        this.$store.state.loadingStatus = true;

      let params = {};
      if (!flag) {
        params = {
          Key: this.moduleDetail.Key,
          PageSize: this.pagination.itemsPerPage,
          Page: this.pagination.page,
        };
      } else if (flag && categoryId) {
        params = {
          CategoryIds: categoryId,
          Key: this.moduleDetail.Key,
          PageSize: this.pagination.itemsPerPage,
          Page: this.pagination.page,
        };
      }

      if(this.minimumDate){
        params['DateFilter'] = this.minimumDate;
      }

      params = { ...params, ...this.filters };

      this.tableData = [];
      ContentService.getPosts(params)
        .then((res) => {
          const data = res.data;
          const list = data?.Data || [];

          if(list?.length > 0){
            this.tableData = res.data.Data;
            this.pagination.totalItems = res.data.TotalData;
          }
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .finally(() => {
          if (flag) {
            this.loadings.table = false;
          } else if (!flag) {
            this.$store.state.loadingStatus = false;
          }
        });
    },

    getCompanyNames(item) {
      let tempString = "";
      item.Groups.forEach((element) => {
        tempString += element.Name + "<br/>";
      });
      return tempString;
    },

    getDetails(item) {
      this.pageHeader = this.moduleDetail.Name;
      //this.$router.push({name:'addContent',params:{data:item,isDetail:true}})
      this.$router.push({
        path: `/home/updateContent/${item.Id}`,
        query: {
          pageName: this.pageHeader || "",
          moduleDescription: this.moduleDescription || "",
          pageId: item.Key || -1,
        },
      });
    },

    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    
    deleteItem() {
      this.publishOperation(this.deleteItemModel, 30)
      return;
      this.$store.state.loadingStatus = true;
      PostService.deletePost(this.deleteItemModel.Id)
        .then(() => {
          this.getTableList();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.handleServiceError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
    },

    publishOperation(item, status) {
      let body = {
        Id: item.Id,
        Status: status
      };

      this.$store.state.loadingStatus = true;
      ContentService.changeContentStatus(body)
        .then(() => {
          item.Status = body.Status;
          window.showSuccess('Durum başarılı bir şekilde güncellendi.')
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.$refs.deleteModalRef.modalStatus = false;
        });
    },

    selectOneCategory(selectedCategory) {
      if (selectedCategory.length > 0) {
        console.log("Selected cat value > ", selectedCategory[0]);
        this.getTableList(selectedCategory[0].Id, true);
      } else {
        console.log("Boş table list");
        this.getTableList();
      }
    },
  },
};
</script>
<style>
.clickable-row {
  cursor: pointer !important;
}
</style>